import React from 'react'

import classnames from 'classnames'
import { Route, Switch, useRouteMatch } from 'react-router-dom'

import { api } from './api'
import { ChannelDetailsPage } from './Components/ChannelDetailsPage'
import { ChannelsList } from './Components/ChannelsList'
import { CurrentUserContext } from './Components/CurrentUserContext'
import { Login } from './Components/Login'
import { Navbar } from './Components/Navbar'
import { Logger } from './utils/Logger'

function App() {
  const [currentUser, setCurrentUser] = React.useState<Api_UserMe.RootObject>()
  const [notConnected, setNotConnected] = React.useState(false)

  const isChannelConversation =
    useRouteMatch('/channels/:channelId')?.isExact === true
  const isChannelDetails =
    useRouteMatch('/channels/:channelId/details')?.isExact === true

  console.log({ isChannelConversation, isChannelDetails })

  const loadCurrentUser = React.useCallback(() => {
    return api
      .getUserMe()
      .then((newUser) => {
        setNotConnected(false)
        setCurrentUser(newUser)
      })
      .catch((err) => {
        Logger.error('could not get user me', err)
        setNotConnected(true)
      })
  }, [])

  React.useEffect(() => {
    loadCurrentUser()
  }, [loadCurrentUser])

  return (
    <CurrentUserContext.Provider value={{ currentUser }}>
      {notConnected && <Login onLoggedIn={loadCurrentUser} />}
      {!notConnected && !currentUser && <div className="loader is-loading" />}
      {!!currentUser && (
        <div
          className="is-flex is-flex-direction-column"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          }}>
          <Navbar />
          <div
            className="columns is-mobile"
            style={{ flex: 1, height: '100%' }}>
            <div
              className={classnames('column m-4 box is-one-quarter-tablet', {
                'is-hidden-mobile': isChannelConversation || isChannelDetails,
              })}
              style={{
                backgroundColor: '#F4F4F4',
                flexFlow: 'column',
                overflowY: 'scroll',
              }}>
              <ChannelsList />
            </div>
            <Switch>
              <Route path="/channels/:channelId">
                <ChannelDetailsPage />
              </Route>
            </Switch>
          </div>
        </div>
      )}
    </CurrentUserContext.Provider>
  )
}

export default App
